import React from "react";

/**
 * @component WarningTriangleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <WarningTriangleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const WarningTriangleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="WarningTriangleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M13.08 2.247c.381.185.694.465.902.805l8.742 14.964c.597.978.194 2.204-.9 2.738a2.472 2.472 0 01-1.082.246H3.258C2.01 21 1 20.097 1 18.982c0-.337.095-.67.276-.966l8.742-14.964c.597-.978 1.968-1.339 3.063-.805zM12 4L3 19h18L12 4zm0 7a3 3 0 110 6 3 3 0 010-6z"
        fillRule="evenodd"
      />
    </svg>
  )
);
WarningTriangleIcon.displayName = "WarningTriangleIcon";
export default WarningTriangleIcon;
